module.exports = __webpack_public_path__ + "img/hf_05.50a8b8ca.png";